export default {"src":"/_next/static/media/payment-visa.4e6067d4.svg","height":30,"width":45,"blurWidth":0,"blurHeight":0};